import {FileOwnershipAccessApi} from 'hemwb-api';
import {configuration} from '../getBackendConfiguration';

const fileOwnershipAccessApi = new FileOwnershipAccessApi(configuration);

export const grantFileOwnership = (fileUuid: string, userId: string) =>
  fileOwnershipAccessApi.grantFileOwnership({fileUuid, userId});
